import CryptoJS from "crypto-js";

/**
 * Decrypts data using AES with a secret key from the environment.
 *
 * @param {string} encryptedData - The encrypted data to decrypt.
 * @param {string} secretKey - The secret key for decryption.
 * @returns {string} - The decrypted data.
 */
export function decryptSessionData(encryptedData: string): string {
  const secretKey = process.env.NEXT_PUBLIC_SESSION_SECRET;
  if (!secretKey) {
    throw new Error("Decryption secret key is not defined.");
  }
  const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
  return bytes.toString(CryptoJS.enc.Utf8);
}
